/* eslint-disable consistent-return */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable react/button-has-type */
import {
  DndContext,
  DragOverlay,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext, arrayMove, rectSortingStrategy, sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import classNames from 'classnames';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDropzone } from 'react-dropzone';

import SectionWrapper from 'components/AddLocation/SectionWrapper';
import Button from 'components/App/Button';
import CardImage from 'components/App/CardImage';
import Loading from 'components/App/Loading';

import { ReactComponent as AddPictureIcon } from 'assets/images/add-picture.svg';

import { LIMIT_FILE_SIZE } from 'constants/index';

import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import { UPLOAD_MULTIPLE_MEDIA } from 'store/media/actionTypes';
import { showToastError } from 'utils';
import styles from './styles.module.scss';

export const getVideoThumbnail = (videoUrl) => new Promise((resolve, reject) => {
  const video = document.createElement('video');
  video.crossOrigin = 'anonymous'; // for S3 CORS
  video.src = videoUrl;
  video.autoplay = false;
  video.muted = true;
  video.preload = 'auto';

  video.addEventListener('loadeddata', () => {
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return reject('Cannot get canvas context');

    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const thumbnail = canvas.toDataURL('image/png');
    resolve(thumbnail);
  });

  video.addEventListener('error', (e) => {
    reject(`Cannot load video: ${e}`);
  });
});

function CardImageWrapper(props) {
  const {
    item,
    onSelectImage,
  } = props;
  const [loading, setLoading] = React.useState(true);
  const [thumbnail, setThumbnail] = React.useState('');

  const getUrlExtension = (url) => {
    try {
      const { pathname } = new URL(url);
      return pathname.split('.').pop()?.toLowerCase() || '';
    } catch {
      return url.split('.').pop()?.toLowerCase()?.split('?')[0] || '';
    }
  };

  const itemExtension = getUrlExtension(item.image);
  const videoExtensions = ['mp4', 'webm', 'mov', 'm4v', 'm3u8'];
  const imageExtensions = ['jpeg', 'jpg', 'png', 'webp', 'gif'];
  const isImage = imageExtensions.includes(itemExtension)
    || (!videoExtensions.includes(itemExtension) && /^https?:\/\//i.test(item.image));

  useEffect(() => {
    if (isImage) {
      setLoading(false);
      setThumbnail(item.image);
    } else {
      getVideoThumbnail(item.image)
        .then(setThumbnail)
        .catch()
        .finally(() => setLoading(false));
    }
  }, [item.image]);

  return (
    <div
      className="position-relative"
      style={{ border: 'solid var(--bookese-gray-700) 1px' }}
    >
      {loading ? (
        <span className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
          <Spinner />
        </span>
      ) : (
        <>
          <CardImage
            item={{ ...item, image: thumbnail }}
            onSelectImage={onSelectImage}
            style={{
              aspectRatio: 1,
              height: 'auto',
              color: 'var(--bookese-white)',
            }}
          />

          {!isImage && (
            <span className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
              <img src="/assets/icon/play_circle_outline.svg" alt="Loading" width={60} height={60} />
            </span>
          )}
        </>
      )}
    </div>
  );
}

const OPTION_UPLOAD_IMAGES = {
  limitValue: 50,
  fileSize: LIMIT_FILE_SIZE.LARGE,
};

const formatUploadImages = (
  file,
  options = {
    limitValue: 0,
    fileSize: LIMIT_FILE_SIZE.LARGE,
  },
) => {
  let fileList;

  if (options.limitValue > 0) {
    fileList = Object.values(file).slice(0, options.limitValue);
  } else {
    fileList = Object.values(file);
  }

  const newFileList = fileList.map((item) => {
    if (item.size > options.fileSizeFormat) {
      showToastError(`Dung lượng ảnh không quá ${options.fileSizeFormat / (1024 * 1024)}MB`);
    }

    return ({
      file: item,
      blob: URL.createObjectURL(item),
    });
  });

  return newFileList.filter((item) => item !== null);
};

function AddImages(props) {
  const {
    value: defaultValue,
    onChange,

    isLoadingUploadMultipleMedia,
    actionUploadMultiMedia,
    multiple,
  } = props;

  const [activeId, setActiveId] = React.useState(null);

  const inputFileRef = React.useRef(null);

  const validation = useFormik({
    validateOnMount: true,
    enableReinitialize: true,
    initialValues: {
      images: defaultValue,
    },

    // validationSchema: Yup.object({
    //   images: Yup.array()
    //     .min(3, 'Số lượng ảnh từ 3 đến 50 ảnh')
    //     .max(50, 'Số lượng ảnh từ 3 đến 50 ảnh')
    //     .test(
    //       'checked',
    //       'Vui lòng chọn ít nhất 3 ảnh',
    //       (value) => value.filter((item) => item.checked).length >= 3,
    //     ),
    // }),
  });

  // Drop And Drag
  const sensors = useSensors(
    useSensor(MouseSensor, {
      // Require the mouse to move by 10 pixels before activating
      activationConstraint: {
        distance: 10,
      },
    }),
    useSensor(TouchSensor, {
      // Press delay of 250ms, with tolerance of 5px of movement
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const onUploadMultiImages = React.useCallback((imageList) => {
    const imageUploadList = formatUploadImages(imageList, OPTION_UPLOAD_IMAGES);

    if (imageUploadList.length > 0) {
      actionUploadMultiMedia({
        images: imageUploadList,
        callback: (values) => {
          const newValues = values.map((item, index) => ({
            image: item,
            id: index + 1,
            checked: true,
          }));

          const images = multiple
            ? [
              ...validation.values.images,
              ...newValues,
            ]
            : [newValues[0]];

          const mappedImages = images
            .map((item, index) => ({
              ...item,
              image: item.image,
              id: index + 1,
            }));

          validation.setFieldValue('images', mappedImages, true);

          inputFileRef.current.value = '';

          onChange(mappedImages);
        },
      });
    }
  }, [actionUploadMultiMedia, onChange, validation, multiple]);

  const onChangeAddImages = React.useCallback((e) => {
    onUploadMultiImages(e.target.files);
  }, [onUploadMultiImages]);

  const onDragStart = React.useCallback((event) => {
    setActiveId(event.active.id);
  }, []);

  const onDragCancel = React.useCallback(() => {
    setActiveId(null);
  }, []);

  const onDragImage = React.useCallback((event) => {
    const { active, over } = event;

    if (active.id !== over?.id) {
      const oldIndex = validation.values.images.findIndex(({ id }) => id === active.id);
      const newIndex = validation.values.images.findIndex(({ id }) => id === over?.id);
      const movedImages = arrayMove(validation.values.images, oldIndex, newIndex);

      validation.setFieldValue('images', movedImages, true);
      setActiveId(null);
      onChange(movedImages);
    }
  }, [onChange, validation, validation.values.images]);

  // Dropzone
  const {
    getRootProps,
    getInputProps,
    isDragAccept,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    accept: {
      'image/*': [
        'image/jpeg',
        'image/png',
        'image/jpg',
      ],
      'video/*': [],
    },
    multiple,
    onDrop: (files) => onUploadMultiImages(files),
  });

  const onClickOpenFileInput = React.useCallback(() => {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }
  }, [inputFileRef]);

  // const onSelectAllImages = React.useCallback(() => {
  //   const images = validation
  //     .values
  //     .images.map((item) => ({ ...item, checked: true }));

  //   validation.setFieldValue('images', images, true);

  //   onChange(images);
  // }, [onChange, validation]);

  // const onClearSelectAllImages = React.useCallback(() => {
  //   const images = validation
  //     .values
  //     .images.map((item) => ({ ...item, checked: false }));

  //   validation.setFieldValue('images', images, true);

  //   onChange(images);
  // }, [onChange, validation]);

  const onSelectImage = React.useCallback((e) => {
    const { name } = e.target;

    const images = validation
      .values
      .images.map((item) => {
        if (String(item.id) === String(name)) {
          return ({
            ...item,
            checked: !item.checked,
          });
        }

        return { ...item };
      });

    validation.setFieldValue('images', images, true);

    onChange(images);
  }, [onChange, validation]);

  const onDeleteSelectedImages = React.useCallback(() => {
    const filterImages = validation.values.images.filter((item) => item.checked !== true);

    validation.setFieldValue('images', filterImages, true);

    onChange(filterImages);
  }, [onChange, validation]);

  return (
    <form className={styles.Component} onSubmit={validation.handleSubmit}>
      <Loading loading={isLoadingUploadMultipleMedia} loaderOnPage />

      <SectionWrapper className={styles.SectionWrapper}>
        {validation.values.images.length > 0 && (
          <div className={styles.ButtonWrap}>
            {/* <Button
              isDefault
              classes={styles.ButtonCheckAll}
              onClick={onSelectAllImages}
            >
              Chọn tất cả
            </Button>

            <Button
              isDefault
              classes={styles.ButtonUnCheck}
              onClick={onClearSelectAllImages}
              disabled={!validation.values.images.some((item) => item.checked)}
            >
              Bỏ chọn tất cả
            </Button> */}

            <Button
              isDefault
              classes={styles.ButtonRemove}
              onClick={onDeleteSelectedImages}
              disabled={!validation.values.images.some((item) => item.checked)}
            >
              Xóa
            </Button>
          </div>
        )}

        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={onDragImage}
          onDragStart={onDragStart}
          onDragCancel={onDragCancel}
        >
          <SortableContext
            items={validation.values.images.map((item) => item.id)}
            strategy={rectSortingStrategy}
          >
            <div className={styles.ImageList} {...getRootProps()}>
              <div className={classNames(
                styles.DropImageLayout,
                isDragAccept && styles.DropImageActive,
              )}
              >
                <AddPictureIcon width={128} height={128} />

                <span>THÊM ẢNH</span>
              </div>

              <input
                {...getInputProps()}
                ref={inputFileRef}
                onChange={onChangeAddImages}
              />

              {validation.values.images.map((image) => (
                <CardImageWrapper
                  item={image}
                  onSelectImage={onSelectImage}
                />
              ))}

              {(multiple || validation.values.images.length === 0) && (
                <Button
                  isDefault
                  id="file"
                  type="button"
                  classes={classNames(
                    styles.UploadImage,
                    validation.values.images.length === 0 && styles.UploadImageFull,
                  )}
                  onClick={onClickOpenFileInput}
                >

                  <AddPictureIcon style={{ width: '44px', height: '44px' }} />

                  <span>
                    Thêm ảnh
                  </span>
                </Button>
              )}
            </div>
          </SortableContext>

          <DragOverlay adjustScale style={{ transformOrigin: '0 0 ' }}>
            {activeId ? <CardImage item={activeId} isDraggingProps /> : null}
          </DragOverlay>
        </DndContext>

        {validation.errors.images && validation.touched.images && (
          <p className={styles.Error}>{validation.errors.images}</p>
        )}

      </SectionWrapper>
    </form>
  );
}

AddImages.propTypes = {
  isLoadingUploadMultipleMedia: PropTypes.bool,

  actionUploadMultiMedia: PropTypes.func.isRequired,
  actionAddLocationByStep: PropTypes.func.isRequired,

  onChange: PropTypes.func.isRequired,

  value: PropTypes.instanceOf(Array),
  multiple: PropTypes.bool,
};

AddImages.defaultProps = {
  isLoadingUploadMultipleMedia: false,

  value: [],
  multiple: true,
};

CardImageWrapper.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
  onSelectImage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
});

const mapDispatchToProps = (dispatch) => ({
  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(AddImages));
